import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AuthGuardService } from './core/services/account/auth-guard.service'
import { NotFoundComponent } from './not-found/not-found.component'
import { UnauthorizedComponent } from './unauthorized/unauthorized.component'

const routes: Routes = [
  {
    path: 'forgot',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'reset',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'force-reset',
    loadChildren: () => import('./force-reset/force-reset.module').then(m => m.ForceResetModule)
  },
  {
    path: 'client',
    loadChildren: () => import('./client/client.module').then(m => m.ClientModule)
  },
  {
    path: 'error',
    loadChildren: () => import('./error-info/error-info.module').then(m => m.ErrorInfoModule)
  },
  {
    path: 'api',
    loadChildren: () => import('./api/api.module').then(m => m.ApiModule),
    canLoad: [AuthGuardService],
    canActivate: [AuthGuardService]
  },
  {
    // canActivate as well as canLoad: the spec behind this page is gated on org-settings access, so the
    // route has to check the same permission or the page loads and then fails its fetch.
    path: 'i-api',
    loadChildren: () => import('./i-api/i-api.module').then(m => m.IApiModule),
    canLoad: [AuthGuardService],
    canActivate: [AuthGuardService]
  },
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad: [AuthGuardService]
  },

  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: NotFoundComponent }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
